export const navbarLinkStyle = { color: "white", textDecoration: "none" };

export const navbarStyle = {
  backgroundColor: "#85cdcb",
};

export const darkNavbarStyle = {
  backgroundColor: "#1a1a1d",
};

export const navbarTextStyle = {
  flexGrow: 1,
  margin: "0.3rem 1rem",
  transitionDuration: "0.2s",
  transitionTimingFunction: "linear",
  "&:hover": {
    color: "#004A55",
  },
};

export const darkNavbarTextStyle = {
  flexGrow: 1,
  margin: "0.3rem 1rem",
  transitionDuration: "0.2s",
  transitionTimingFunction: "linear",
  "&:hover": {
    color: "#950740",
  },
};

export const switchStyle = {
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#004A55",
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#004A55",
  },
};

export const darkSwitchStyle = {
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#950740",
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#950740",
  },
};

export const switchIconStyle = {
  color: "white",
};
